import type { TFetchPartsOptions } from '@/store/fetchableParts/types';

import getEnvTimeSettings from '@/store/fetchableParts/helpers/getEnvTimeSettings';

// TODO: use inside client instead

export const getApolloDefaultFetchOptions = () => {
  const { revalidate, timeout } = getEnvTimeSettings();
  const fetchOptions: TFetchPartsOptions = {
    next: { revalidate },
    timeout,
  };

  return fetchOptions;
};
